<template>
    <FormControl
        :label="customField.title"
        :required="customField.isRequired"
        :error="
            errors.getValidationErrorUsingRawString(`${customField.id.value}`)
        "
    >
        <template
            v-if="
                typeof savedValue.response === 'string' ||
                savedValue.response === null
            "
        >
            <input
                type="hidden"
                :name="`${RequestBodyKeyEnum.ScheduleMeeting_CustomFieldResponses}[${customField.id.value}][${RAW_RESPONSE_CUSTOM_FIELD_ID_KEY}]`"
                :value="customField.id.value"
            />
            <template
                v-if="
                    localSettings.data.numberType ===
                    CustomFieldNumberTypeEnum.Integer
                "
            >
                <TextInput
                    type="number"
                    mode="numeric"
                    :min="localSettings.data.numberMinValue"
                    :max="localSettings.data.numberMaxValue"
                    step="1"
                    :useBookingFormThemeCssVariables="true"
                    :required="customField.isRequired"
                    :name="`${RequestBodyKeyEnum.ScheduleMeeting_CustomFieldResponses}[${customField.id.value}][${RAW_RESPONSE_CONTENT_KEY}]`"
                    :modelValue="savedValue.response ?? undefined"
                />
            </template>
            <template
                v-else-if="
                    localSettings.data.numberType ===
                    CustomFieldNumberTypeEnum.Decimal
                "
            >
                <TextInput
                    type="number"
                    mode="numeric"
                    :min="localSettings.data.numberMinValue"
                    :max="localSettings.data.numberMaxValue"
                    :step="localSettings.data.numberStepValue"
                    :useBookingFormThemeCssVariables="true"
                    :required="customField.isRequired"
                    :name="`${RequestBodyKeyEnum.ScheduleMeeting_CustomFieldResponses}[${customField.id.value}][${RAW_RESPONSE_CONTENT_KEY}]`"
                    :modelValue="savedValue.response ?? undefined"
                />
            </template>
        </template>
        <template v-else>
            <UnexpectedError />
        </template>
    </FormControl>
</template>

<script setup lang="ts">
    import { type PropType } from 'vue'
    import CustomField from '@/App/CustomField/Entity/CustomField'
    import TextInput from '@/Shared/Component/Forms/TextInput.vue'
    import FormControl from '@/Shared/Component/Forms/FormControl.vue'
    import {
        CustomFieldNumberTypeEnum,
        RAW_RESPONSE_CONTENT_KEY,
        RAW_RESPONSE_CUSTOM_FIELD_ID_KEY,
        type CustomFieldResponseDTO,
        type CustomFieldSettingsNumberType,
    } from '@/Shared/AutoGenerated/Main'
    import type ApiFormErrors from '@/Shared/Component/Forms/ApiFormErrors'
    import UnexpectedError from '@/BookingForm/BookingForm/Component/CustomField/UnexpectedError.vue'
    import { RequestBodyKeyEnum } from '@/Shared/AutoGenerated/RequestFieldEnum'

    const props = defineProps({
        customField: {
            type: Object as PropType<CustomField>,
            required: true,
        },
        errors: {
            type: Object as PropType<ApiFormErrors>,
            required: true,
        },
        savedValue: {
            type: Object as PropType<CustomFieldResponseDTO>,
            required: true,
        },
    })

    const localSettings: CustomFieldSettingsNumberType =
        props.customField.settings
</script>
